import { extendTheme } from '@chakra-ui/react';
import {
  BG_SECONDARY,
  BG_PRIMARY,
  BG_SECONDARY_TRANSPARENT,
  BG_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_PRIMARY_LIGHT,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: 'Noto Serif Display',
    subHeading: 'Noto Serif Display',
    body: 'Tinos',
    body_lv2: 'Noto Serif Display',
    fullName: 'Noto Serif Display',

    jost: `'Jost', serif`,
  },
  fontSizes: {
    heading: '36px',
    subHeading: '22px',
    body: '16px',
    body_lv2: '18px',
    fullName: '26px',
  },
  fontWeights: {
    heading: 700,
    subHeading: 700,
    body: 500,
    body_lv2: 700,
    fullName: 700,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
        '--fontItalic-fullName': '',
      },
    },
  },
  colors: {
    bgPrimary: '#FFF',
    bgSecondary: 'rgba(0,0,0,1)',
    bgAlternative: 'rgba(159,139,94,1)',
    mainColorText: 'rgba(0,0,0,1)',
    secondaryColorText: '#FFF',
    mainColorTextLight: '#FFF',

    transparent: 'transparent',
    theme: {
      bgPrimaryText: TEXT_PRIMARY,
      bgPrimary: BG_PRIMARY,
      bgSecondary: BG_SECONDARY,
      bgSecondaryTransparent: BG_SECONDARY_TRANSPARENT,
    },
    button: {
      secondary: {
        500: BG_SECONDARY,
      },
      secondaryDark: {
        500: BG_ALTERNATIVE,
      },
    },
  },
  shadows: {
    outline: BG_ALTERNATIVE,
  },
  breakpoints: {
    base: '0',
    xs: '360px',
    sm: '480px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    '2xl': '1400px',
  },
};

export default extendTheme(theme);
